export default function HoursLocation() {
  return (
    <section id="hours-location" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-10 gap-12">
          <div className="md:col-span-4">
            <div className="mb-4">
              <span className="text-pink-600 text-sm font-semibold tracking-wider uppercase">Visit Us</span>
            </div>
            <address className="not-italic">
              <p className="text-2xl font-bold text-gray-900 leading-relaxed mb-8">
                2645 N Berkeley Lake Rd NW<br />
                STE 228<br />
                Duluth, GA 30096
              </p>
            </address>
            <div className="rounded-2xl overflow-hidden shadow-xl h-80 w-full">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3307.8!2d-84.1447!3d34.0028!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5a1e8e8e8e8e8%3A0x1234567890abcdef!2s2645%20N%20Berkeley%20Lake%20Rd%20NW%20STE%20228%2C%20Duluth%2C%20GA%2030096!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Gang Nam Style Karaoke Location"
              ></iframe>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="mb-4">
              <span className="text-pink-600 text-sm font-semibold tracking-wider uppercase">Hours</span>
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-4">Open 7 Days</h3>
            <div className="text-4xl font-bold text-pink-600 mb-2">5 PM - 1 AM</div>
            <p className="text-lg text-gray-600 mb-8">Monday - Sunday</p>
            
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-6 border-2 border-pink-200">
              <div className="flex items-start gap-3 mb-4">
                <i className="ri-information-line text-2xl text-pink-600 mt-1"></i>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Walk-ins Welcome</h4>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    We accept walk-ins based on availability. For guaranteed seating, especially on weekends, we recommend booking in advance.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="mb-4">
              <span className="text-pink-600 text-sm font-semibold tracking-wider uppercase">Contact</span>
            </div>
            <a
              href="tel:+14702683498"
              className="text-3xl font-bold text-gray-900 hover:text-pink-600 transition-colors flex items-center gap-3 mb-2 cursor-pointer"
            >
              <i className="ri-phone-line text-pink-600"></i>
              (470) 268-3498
            </a>
            <p className="text-base text-gray-600 mb-8">Call to Reserve</p>

            <div className="mb-8">
              <h4 className="font-bold text-gray-900 mb-4">Follow Us</h4>
              <div className="flex gap-4">
                <a
                  href="https://www.instagram.com/gangnamstylekaraokeatl/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-pink-600 text-white rounded-full flex items-center justify-center hover:bg-pink-700 transition-all hover:scale-110 cursor-pointer"
                >
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61587411106221"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-pink-600 text-white rounded-full flex items-center justify-center hover:bg-pink-700 transition-all hover:scale-110 cursor-pointer"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a
                  href="https://www.tiktok.com/@kangnamstylekaraoke"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-pink-600 text-white rounded-full flex items-center justify-center hover:bg-pink-700 transition-all hover:scale-110 cursor-pointer"
                >
                  <i className="ri-tiktok-fill text-xl"></i>
                </a>
              </div>
            </div>

            <div className="bg-gray-900 text-white rounded-2xl p-6">
              <h4 className="font-bold mb-3">Getting Here</h4>
              <p className="text-sm text-gray-300 leading-relaxed">
                Located in the heart of Duluth with ample parking. Easy access from I-85 and Highway 120.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}